import { ButtonHTMLAttributes, ReactNode } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  children: ReactNode
}

export const Button = ({ 
  variant = 'primary', 
  size = 'md',
  children, 
  className = '', 
  ...props 
}: ButtonProps) => {
  const baseClasses = 'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-offset-2'
  
  const variantClasses = {
    primary: 'btn-primary bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500 shadow-lg hover:shadow-xl',
    secondary: 'btn-secondary bg-gray-800 text-white hover:bg-gray-900 focus:ring-gray-700 shadow-md hover:shadow-lg',
    outline: 'btn-outline border-2 border-primary-600 text-primary-700 bg-white hover:bg-primary-50 hover:border-primary-700 focus:ring-primary-500 font-semibold',
    ghost: 'btn-ghost text-gray-800 hover:bg-gray-100 focus:ring-gray-500 font-medium',
  }

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
  }

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      style={{
        // Estilos inline como fallback para garantir visibilidade
        ...(variant === 'primary' && {
          backgroundColor: '#0284c7',
          color: '#ffffff',
        }),
        ...(variant === 'secondary' && {
          backgroundColor: '#1f2937',
          color: '#ffffff',
        }),
        ...(variant === 'outline' && {
          backgroundColor: '#ffffff',
          color: '#0284c7',
          border: '2px solid #0284c7',
        }),
        ...(variant === 'ghost' && {
          backgroundColor: 'transparent',
          color: '#1f2937',
        }),
      }}
      {...props}
    >
      {children}
    </button>
  )
}

